import React from "react";
import { useLang } from "../lib/LangContext";
import { Utensils, BedDouble, Check } from "lucide-react";

const DINING_IMG =
  "https://customer-assets.emergentagent.com/job_a942c98c-21f3-4b68-8acb-90399d58ab6a/artifacts/c143rofl_Screenshot%202026-06-24%20at%2003.06.57.png";
const STAY_IMG =
  "https://images.pexels.com/photos/29870238/pexels-photo-29870238.jpeg";

const VoucherCard = ({ tag, title, desc, points, img, icon: Icon, reverse, testId }) => (
  <div
    data-testid={testId}
    className={`grid grid-cols-1 lg:grid-cols-2 gap-0 border border-brand-yellow/30 ${
      reverse ? "lg:[direction:rtl]" : ""
    }`}
  >
    <div className="relative aspect-[4/3] lg:aspect-auto overflow-hidden bg-black [direction:ltr]">
      <img src={img} alt={title} className="absolute inset-0 w-full h-full object-cover" />
      <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent" />
      <div className="absolute top-6 left-6 inline-flex items-center gap-2 bg-brand-yellow text-black px-3 py-1.5 font-anton uppercase text-xs tracking-widest">
        <Icon size={14} />
        {tag}
      </div>
    </div>
    <div className="bg-[#0a0a0a] p-6 md:p-10 lg:p-14 flex flex-col justify-center [direction:ltr]">
      <h3 className="font-anton uppercase text-white leading-tight mb-4" style={{ fontSize: "clamp(1.75rem, 3.5vw, 3rem)" }}>
        {title}
      </h3>
      <p className="text-white/70 leading-relaxed mb-6 text-sm md:text-base">{desc}</p>
      <ul className="space-y-2.5">
        {points.map((p, i) => (
          <li key={i} className="flex items-start gap-3 text-white/85">
            <Check size={16} className="text-brand-yellow flex-shrink-0 mt-1" />
            <span className="text-sm">{p}</span>
          </li>
        ))}
      </ul>
    </div>
  </div>
);

const Services = () => {
  const { t } = useLang();
  return (
    <section
      id="services"
      data-testid="services-section"
      className="relative bg-gradient-to-b from-black via-[#070707] to-black py-20 md:py-28 overflow-hidden"
    >
      <div className="max-w-screen-2xl mx-auto px-6 md:px-12 lg:px-20">
        <div className="max-w-3xl mb-12 md:mb-16">
          <div className="flex items-center gap-3 mb-5">
            <div className="h-px w-8 bg-brand-yellow" />
            <span className="text-[11px] uppercase tracking-[0.4em] text-brand-yellow font-semibold">
              {t.services.eyebrow}
            </span>
          </div>
          <h2 className="font-anton uppercase text-white leading-[0.95]" style={{ fontSize: "clamp(2rem, 4.5vw, 3.75rem)" }}>
            {t.services.title}
          </h2>
        </div>

        <div className="space-y-10 md:space-y-12">
          <VoucherCard
            testId="service-dining"
            tag={t.services.diningTag}
            title={t.services.diningTitle}
            desc={t.services.diningDesc}
            points={t.services.diningPoints}
            img={DINING_IMG}
            icon={Utensils}
          />
          <VoucherCard
            testId="service-stay"
            tag={t.services.stayTag}
            title={t.services.stayTitle}
            desc={t.services.stayDesc}
            points={t.services.stayPoints}
            img={STAY_IMG}
            icon={BedDouble}
            reverse
          />
        </div>
      </div>
    </section>
  );
};

export default Services;
